<template>
  <div id="our-promise-component">
    <div id="our-promise-content">
      <picture>
        <source srcset="@/assets/images/frames/child-with-mask.webp" />
        <img src="@/assets/images/frames/child-with-mask.png" alt="" />
      </picture>
      <div id="info-container">
        <h2>our promise</h2>
        <p>
          As a member church of the Baptist Union of Great Britain (BUGB) we
          have a safeguarding statement and procedures book which are based on
          the model policy and procedures provided by BUGB (These are available
          in Church).
          <br /><br />
          The Leadership Team and others who work with children, young people
          and / or adults at risk all undergo DBS checks (via the Disclosure and
          Barring Service) and also receive appropriate training in
          safeguarding. As a Church family we seek to keep everyone, who part of
          The Bridge Baptist Church, as safe as possible.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurPromiseComponent",
};
</script>

<style scoped>
#our-promise-component {
  position: relative;
  display: flex;
  justify-content: center;
  width: 100%;
  padding: 4rem 8rem;
  background-color: var(--grey-1);
}

#our-promise-content {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 4rem;
  width: 100%;
  max-width: 90rem;
}

#our-promise-content picture {
  position: relative;
  width: 40%;
  max-width: 32rem;
}

#our-promise-content picture img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#info-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 2rem;
  width: 60%;
}

h2 {
  text-align: left;
}

@media screen and (max-width: 900px) {
  #our-promise-component {
    padding: 4rem 4rem;
  }
}

@media screen and (max-width: 750px) {
  #our-promise-component {
    padding: 4rem 2rem;
  }

  #our-promise-content {
    flex-direction: column;
    justify-content: unset;
    align-items: center;
    row-gap: 2rem;
  }

  #our-promise-content picture {
    width: 100%;
    max-width: 24rem;
  }

  #info-container {
    flex-direction: column;
    align-items: center;
    width: 100%;
    text-align: center;
  }

  h2 {
    text-align: center;
  }
}
</style>
